import React, { Component } from 'react';
import {
  arrayOf,
  number,
  shape,
  bool,
  func,
  oneOfType,
  string,
} from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { withTranslation } from 'react-i18next';
import T from 'aegisv2/Text';
import { formatCourseV2, checkIfisInShoppingCart } from 'Catalog/utils';
import { secondaryMain } from 'crehana-ui/styles/colors';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import getCommunityRecommended from 'Jsx/Catalog/graphql/searchCourses.graphql';

import CourseListSlider from './CourseListSlider';

class CommunityRecommeded extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      this.props.loading !== nextProps.loading ||
      this.props.courseIdsOwned.length !== nextProps.courseIdsOwned.length ||
      this.props.loadingCartButton !== nextProps.loadingCartButton
    );
  }

  render() {
    const {
      courseIdsOwned,
      removeCourseFromCart,
      addCourseToCart,
      user,
      loading,
      courses,
      error,
      size,
      loadingCartButton,
      userLanguage,
      t,
    } = this.props;

    if (error) {
      return (
        <div style={{ padding: '24px 0', marginBottom: '0' }}>
          <T color={{ secondaryMain }} bold xs>
            Ocurrió un error al intentar obtener los cursos recomendados,
            intente recargar la página.
          </T>
        </div>
      );
    }
    return (
      <CourseListSlider
        userLanguage={userLanguage}
        courseIdsOwned={courseIdsOwned}
        removeCourseFromCart={removeCourseFromCart}
        addCourseToCart={addCourseToCart}
        skeletonItems={size}
        courses={courses}
        title={t('COURSE_RECOMMENDATION')}
        hasMainTitle
        isUserLogged={!!user}
        user={user}
        loading={loading || typeof window === 'undefined'}
        loadingCartButton={loadingCartButton}
        name="CommunityRecommended"
      />
    );
  }
}

CommunityRecommeded.defaultProps = {
  user: null,
  error: false,
};

CommunityRecommeded.propTypes = {
  courseIdsOwned: arrayOf(number).isRequired,
  removeCourseFromCart: func.isRequired,
  addCourseToCart: func.isRequired,
  courses: arrayOf(
    shape({
      originalId: number.isRequired,
    }),
  ).isRequired,
  loading: bool.isRequired,
  user: shape({}),
  error: oneOfType([bool, shape({})]),
  size: number.isRequired,
  loadingCartButton: bool.isRequired,
  userLanguage: string.isRequired,
};

export default compose(
  withTranslation(CATALOG_TRANSLATION_KEY),
  graphql(getCommunityRecommended, {
    name: 'data',
    options: ({ size }) => ({
      variables: {
        pageSize: size,
        listRecommended: 'community-recommended',
      },
    }),
    props: ({
      ownProps: { courseIdsOwned },
      data: { loading, error, searchCourses },
    }) => ({
      loading,
      error,
      courses: searchCourses
        ? searchCourses.edges
            .map(e => e.node)
            .map(formatCourseV2)
            .map(checkIfisInShoppingCart(courseIdsOwned))
        : [],
    }),
  }),
)(CommunityRecommeded);
